export default __webpack_public_path__ + "static/media/logo_ontimeoxy.3f2016d0.png";